import { render, staticRenderFns } from "./button-loader.vue?vue&type=template&id=f4dbf410&scoped=true&"
import script from "./button-loader.vue?vue&type=script&lang=js&"
export * from "./button-loader.vue?vue&type=script&lang=js&"
import style0 from "./button-loader.vue?vue&type=style&index=0&id=f4dbf410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dbf410",
  null
  
)

export default component.exports